<!--
  Generated template for the RegistrationPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>
  <ion-toolbar>
    <ion-title>
      {{ 'REG_PAGE_TITLE' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content padding class="bg-white">
  <ion-grid>
    <ion-row>
      <ion-col col-12>
        <ion-label>{{ 'LOGIN_ID' | translate }}</ion-label>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col col-12>
        <ion-input type="text" [(ngModel)]="id"></ion-input>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col col-12 text-center>
        <button ion-button block [disabled]="id.length===0" (click)="login()">{{ 'GLOBAL_OK' | translate }}</button>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="eventId != -1">
      <ion-col col-12 text-center>
        <button ion-button block *ngIf="!registrationClosed" (click)="onRegister()">{{ 'RACE_RESULT_ANMELDEN_MESSAGE' |
          translate }}
        </button>
        <button *ngIf="registrationClosed">{{ 'RACE_RESULT_ANMELDEN_NOT_POSSIBLE' | translate }}</button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col col-12 text-center>
        <div class="empty-block">
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col col-12 padding>
        <img src="/assets/imgs/sponsors/hella/hella/4.jpg" />
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>